import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { TimeTrackingConfiguration } from './timeTrackingConfigurationTypes';
export class TimeTrackingConfigurationRepository extends EntityRepository<AppSynchronizationEnvironmentTypes, EntityName.TimeTrackingConfiguration, AppEntityManagerEntityTypesByEntityName> {
  public getByUserGroupId(userGroupId: string): Array<TimeTrackingConfiguration> {
    return this.getAll().filter(config => config.ownerUserGroupId === userGroupId);
  }
}